<template lang="pug">
footer#footer(:class="{ 'service-main-footer': currentRoutePath === 'my-projects' && currentService }")
        .bq-ft-wrap
            .bq-ft-left
                router-link.bq-ft-logo(to="/" style='margin-right: 2rem;') BunnyQuery
                .bq-ft-info
                    a.bq-ft-terms(href="/tspp-bq.html" target="_blank" data-track="footer_terms_of_service") Terms of service / Privacy policy
                    span.bq-ft-company {{ new Date().getFullYear() }} BROADWAYINC PTE. LTD. Singapore.
            .bq-ft-right
                span.bq-ft-email support&#64;broadwayinc&#46;com
                .bq-ft-icons
                    a.bq-ft-icon(href="http://www.tiktok.com/@skapi_api" target="_blank" data-track="footer_tiktok_icon")
                        img.bq-ft-svg(:src="iconTiktok" alt="TikTok")
                    a.bq-ft-icon(href="https://www.instagram.com/skapi_api" target="_blank" data-track="footer_instagram_icon")
                        img.bq-ft-svg(:src="iconInstagram" alt="Instagram")
                    a.bq-ft-icon(href="https://www.youtube.com/@skapi_official" target="_blank" data-track="footer_youtube_icon")
                        img.bq-ft-svg(:src="iconYoutube" alt="YouTube")
                    a.bq-ft-icon(href="https://x.com/skapi_api" target="_blank" data-track="footer_x_icon")
                        img.bq-ft-svg(:src="iconX" alt="X")
                    a.bq-ft-icon(href="https://www.linkedin.com/company/skapi-backend-api/" target="_blank" data-track="footer_linkedin_icon")
                        img.bq-ft-svg(:src="iconLinkedin" alt="LinkedIn")
                    a.bq-ft-icon(href="https://www.facebook.com/profile.php?id=61577236221327" target="_blank" data-track="footer_facebook_icon")
                        img.bq-ft-svg(:src="iconFacebook" alt="Facebook")
                    a.bq-ft-icon(href="https://dev.to/skapi_api" target="_blank" data-track="footer_devto_icon")
                        img.bq-ft-svg(:src="iconDevto" alt="Dev.to")
</template>

<script setup>
import { onMounted, onUnmounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { currentService } from "@/views/project-list";

import iconTiktok from "@/assets/img/landingpage/icon_tiktok.svg";
import iconInstagram from "@/assets/img/landingpage/icon_instagram.svg";
import iconYoutube from "@/assets/img/landingpage/icon_youtube.svg";
import iconX from "@/assets/img/landingpage/icon_x.svg";
import iconLinkedin from "@/assets/img/landingpage/icon_linkedin.svg";
import iconFacebook from "@/assets/img/landingpage/icon_facebook.svg";
import iconDevto from "@/assets/img/landingpage/icon_devto.svg";

const router = useRouter();
const route = useRoute();
const hoveredMenu = ref("");
let currentRoutePath = ref(route.path);

const scrollSec = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
        const remOffset =
            4 * parseFloat(getComputedStyle(document.documentElement).fontSize);
        const scrollY = section.offsetTop - remOffset;
        window.scrollTo({ top: scrollY, behavior: "smooth" });
    }
};

function setFooterHeight() {
    const footerElement = document.getElementById("footer");

    if (!footerElement) {
        return;
    }

    const height = footerElement.offsetHeight;

    if (height) {
        document.body.style.setProperty("--footer-height", height + "px");
    }
}

watch(
    () => route.path,
    (nv) => {
        let splitPath = nv.split("/");

        currentRoutePath.value = splitPath.length > 2 ? splitPath[1] : "";
    },
    { immediate: true }
);

onMounted(() => {
    setFooterHeight();
});
</script>

<style lang="less" scoped>
@import "@/assets/less/bq-tokens.less";

#footer {
    position: relative;
    background: @paper;
    color: @ink;
    font-family: @mono;
    font-size: 0.85rem;
    border-top: 1px solid @line;
    z-index: 999;

    a {
        color: @ink;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }

    a.bq-ft-logo {
        text-decoration: none;

        &:hover {
            text-decoration: none;
        }
    }
}

/* ─── shared inner ─── */
.bq-ft-inner {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 2rem;
}

.bq-ft-logo {
    display: block;
    font-weight: 700;
    font-size: 1.05rem;
    letter-spacing: 0.04em;
    color: @ink;
    text-decoration: none;
    margin-bottom: 1rem;
}

/* ─── home footer: top ─── */
.bq-ft-top {
    padding: 2.5rem 0;
    border-bottom: 1px solid @line;

    .bq-ft-inner {
        align-items: flex-start;
    }
}

.bq-ft-left {
    display: flex;
    flex-wrap: wrap;
    // gap: 2rem;
    flex: 1;
    min-width: 0;
}

.bq-ft-sections,
.bq-ft-nav {
    list-style: none;
    margin: 0;
    padding: 0;

    li {
        padding: 0.25rem 0;
        font-size: 0.85rem;
        cursor: pointer;
        color: @muted;
        transition: color 0.15s;

        &:hover {
            color: @ink;
        }

        a {
            color: inherit;
            text-decoration: none;

            &:hover {
                text-decoration: underline;
                color: @ink;
            }
        }
    }
}

.bq-ft-right {
    text-align: right;
}

.bq-ft-email {
    display: block;
    margin: 0 0 0.25rem;
    font-size: 0.85rem;
    color: @muted;
}

.bq-ft-terms {
    display: block;
    font-size: 0.8rem;
    color: @muted;
    cursor: pointer;

    &:hover {
        color: @ink;
    }
}

/* ─── home footer: bottom ─── */
.bq-ft-bottom {
    padding: 1.25rem 0;

    .bq-ft-inner {
        align-items: center;
    }
}

.bq-ft-company {
    font-size: 0.75rem;
    color: @muted;
}

.bq-ft-icons {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;
}

.bq-ft-icon {
    display: inline-block;

    &:hover .bq-ft-svg {
        filter: brightness(0) saturate(100%) invert(19%) sepia(89%) saturate(2510%) hue-rotate(313deg) brightness(93%) contrast(90%);
        opacity: 1;
    }
}

.bq-ft-svg {
    display: block;
    width: 1.75rem;
    height: 1.75rem;
    object-fit: contain;
    // Monochrome SVGs ship as solid black. `--bq-icon-invert` flips them
    // to white in dark mode so they read on the dark @paper surface.
    filter: brightness(0) saturate(100%) invert(var(--bq-icon-invert));
    opacity: 0.8;
    transition: filter 0.15s, opacity 0.15s;
}

/* ─── non-home footer ─── */
.bq-ft-wrap {
    padding: 2rem 2rem;
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 0.5rem;

    .bq-ft-right {
        text-align: right;
    }
}

.bq-ft-info {
    .bq-ft-terms {
        margin-bottom: 0.25rem;
    }

    .bq-ft-company {
        display: block;
    }
}

/* ─── responsive ─── */
@media (max-width: 800px) {
    #footer {
        display: none;
    }

    .bq-ft-inner {
        padding: 0 1.25rem;
    }

    .bq-ft-top {
        .bq-ft-left {
            flex-direction: column;
            gap: 1.25rem;
        }
    }

    .bq-ft-bottom {
        .bq-ft-inner {
            flex-direction: column-reverse;
            align-items: flex-start;
            gap: 1rem;
        }
    }

    .bq-ft-right {
        text-align: left;
    }

    .bq-ft-wrap {
        flex-direction: column;
        align-items: flex-start;
        padding: 2rem 1.25rem;

        .bq-ft-right {
            text-align: left;
        }
    }

    #footer.service-main-footer {
        margin-left: 0;

        .bq-ft-wrap {
            padding: 1.875rem 1.25rem;
        }
    }
}
</style>
